import "./App.css";
import Contact from "./components/Contact";

import Header from "./components/Header";
import Home from "./components/Home";

function App() {
  return (
    <>
      <Header />
      <Home />
      <Contact />
    </>
  );
}

export default App;
